module.exports = __webpack_public_path__ + "2b11e3c04831d3e609387cbe136c22b6.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Roboto-Italic-webfont.woff
// module id = 221
// module chunks = 0